import { useFormContext, useWatch } from 'react-hook-form';

import { VariantBaseButton, VariantFieldset } from '@libs/shared-ui';

import type { FormFields } from '@/entities/purchase-form';

type FontsProps = {
    fonts: string[];
};

export const Fonts = ({ fonts }: FontsProps) => {
    const { register } = useFormContext<FormFields>();
    const currentFont: string | undefined = useWatch({ name: 'personalization.fontFace' });

    return (
        <VariantFieldset legendKey="Font" legendValue={currentFont ?? 'Select fonts'}>
            {fonts.map(font => (
                <VariantBaseButton
                    key={font}
                    label={font}
                    value={font}
                    isChecked={currentFont === font}
                    {...register('personalization.fontFace')}
                />
            ))}
        </VariantFieldset>
    );
};
